module.exports = __webpack_public_path__ + "static/pointer.5ed21f23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pointer.svg
// module id = 451
// module chunks = 35783957827783 172322841747965